var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon19(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4425 47.9921C13.1262 47.9921 12.881 47.8337 12.6437 47.6753C12.1612 47.1129 0.400391 33.2515 0.400391 23.9604C0.400391 20.5149 1.76076 17.2277 4.15722 14.7485C6.64069 12.2614 9.91507 10.899 13.3555 10.899C16.796 10.899 20.1574 12.2614 22.6329 14.8277C25.0294 17.3149 26.3898 20.5149 26.3107 23.9604C26.3107 31.4139 14.708 46.9545 14.1464 47.5961C13.9883 47.8337 13.7431 48 13.4267 48L13.4425 47.9921ZM13.4425 12.9743C10.4845 12.9743 7.6847 14.099 5.60461 16.2614C3.52451 18.3446 2.40137 21.0693 2.40137 24.0317C2.40137 31.2396 10.7218 42.1386 13.3635 45.4258C14.3995 43.905 16.4875 41.0218 18.5676 37.7347C22.4115 31.5644 24.4046 26.8357 24.4916 24.0317C24.5707 21.1485 23.4555 18.4238 21.3675 16.3406C19.2083 14.099 16.4085 12.9743 13.4504 12.9743H13.4425Z",
    fill: "url(#paint0_linear_403_146)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5177 24.998C39.1934 24.998 38.9561 24.8396 38.7189 24.6812C38.3946 24.2772 30.6357 15.0653 30.5566 8.89505C30.5566 6.49505 31.4345 4.32475 33.1192 2.64554C34.7959 0.966334 37.0421 0 39.4386 0C41.835 0 44.0812 0.958413 45.8371 2.64554C47.5138 4.32475 48.3996 6.57425 48.3996 8.89505C48.3996 11.0574 46.9601 14.3446 44.3185 18.7485C42.3175 21.9564 40.3956 24.5149 40.3165 24.5941C40.1583 24.8317 39.8341 24.9109 39.5177 24.998ZM39.5177 1.91683C37.6749 1.91683 35.919 2.63762 34.6377 3.92079C33.3564 5.20396 32.6367 6.96237 32.6367 8.80792C32.6367 13.2119 37.5167 19.7861 39.5177 22.3525C42.0012 18.9069 46.3986 12.095 46.4777 8.80792C46.4777 6.96237 45.8371 5.28317 44.5558 4C43.1163 2.63763 41.3526 1.91683 39.5177 1.91683Z",
    fill: "url(#paint1_linear_403_146)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4404 13.9406C36.7197 13.9406 34.4023 11.699 34.4023 8.89503C34.4023 6.09107 36.6406 3.84949 39.4404 3.84949C42.2403 3.84949 44.4786 6.09107 44.4786 8.89503C44.4786 11.699 42.1612 13.9406 39.4404 13.9406ZM39.4404 5.92473C37.7637 5.92473 36.4034 7.2871 36.4034 8.96631C36.4034 10.6455 37.7637 12.0079 39.4404 12.0079C41.1172 12.0079 42.4776 10.6455 42.4776 8.96631C42.4776 7.2871 41.0381 5.92473 39.4404 5.92473Z",
    fill: "url(#paint2_linear_403_146)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4386 31.9683H7.44039C6.87884 31.9683 6.4043 31.4852 6.4043 30.9228V18.9069C6.4043 18.3446 6.88675 17.8693 7.44039 17.8693H11.4425C12.004 17.8693 12.4785 18.3525 12.4785 18.9069C12.4785 19.4614 11.9961 19.9446 11.4425 19.9446H8.40533V29.9644H18.4104V19.9446H15.3733C14.8117 19.9446 14.3372 19.4614 14.3372 18.9069C14.3372 18.3525 14.8196 17.8693 15.3733 17.8693H19.3753C19.9368 17.8693 20.4114 18.3525 20.4114 18.9069V30.9228C20.4114 31.4852 19.9289 31.9683 19.4543 31.9683H19.4386Z",
    fill: "url(#paint3_linear_403_146)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4425 23.9525H11.4405C10.8789 23.9525 10.3965 23.4693 10.3965 22.9149V18.9069C10.3965 18.3446 10.8789 17.8693 11.4405 17.8693H15.4425C16.0041 17.8693 16.4865 18.3525 16.4865 18.9069V22.9149C16.4074 23.4772 15.925 23.9525 15.4425 23.9525ZM12.3975 21.9485H14.3985V19.9446H12.3975V21.9485Z",
    fill: "url(#paint4_linear_403_146)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4464 37.9802H29.4444C28.8829 37.9802 28.4004 37.497 28.4004 36.9426V28.9267C28.4004 28.3644 28.8829 27.8812 29.4444 27.8812H38.4054V23.8733C38.4054 23.3109 38.8879 22.8277 39.4495 22.8277C40.011 22.8277 40.4935 23.3109 40.4935 23.8733V28.9188C40.4935 29.4812 40.011 29.9644 39.4495 29.9644H30.4093V35.9762H33.4464C34.008 35.9762 34.4904 36.4594 34.4904 37.0139C34.4113 37.497 33.9289 37.9723 33.4464 37.9723V37.9802Z",
    fill: "url(#paint5_linear_403_146)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4055 47.9921H13.4423C12.8808 47.9921 12.4062 47.5089 12.4062 46.9545C12.4062 46.4 12.8887 45.9089 13.4423 45.9089H41.4485V37.9802H39.4475C38.886 37.9802 38.4035 37.497 38.4035 36.9426C38.4035 36.3881 38.886 35.897 39.4475 35.897H42.4055C42.9671 35.897 43.4416 36.3802 43.4416 36.9426V46.9545C43.4416 47.5168 42.9592 47.9921 42.4055 47.9921Z",
    fill: "url(#paint6_linear_403_146)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_403_146",
    x1: 13.3572,
    y1: 10.899,
    x2: 13.3572,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_403_146",
    x1: 39.4781,
    y1: 0,
    x2: 39.4781,
    y2: 24.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_403_146",
    x1: 39.4404,
    y1: 3.84949,
    x2: 39.4404,
    y2: 13.9406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_403_146",
    x1: 13.4078,
    y1: 17.8693,
    x2: 13.4078,
    y2: 31.9683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_403_146",
    x1: 13.4415,
    y1: 17.8693,
    x2: 13.4415,
    y2: 23.9525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_403_146",
    x1: 34.4469,
    y1: 22.8277,
    x2: 34.4469,
    y2: 37.9802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_403_146",
    x1: 27.9239,
    y1: 35.897,
    x2: 27.9239,
    y2: 47.9921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon19);
export default __webpack_public_path__ + "static/media/icon19.1a462fbaabd5facf26d825b0ee2736d3.svg";
export { ForwardRef as ReactComponent };